require('./forgot-password-template.html');

exports.inject = function(module) {
  module.config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/forgot-password', {
      templateUrl: 'forgot-password-template.html',
      controller: 'ForgotPasswordController',
      loginLayout: true
    });
  }]);
  module.controller('ForgotPasswordController', ['$scope', '$timeout', '$location', 'Auth', exports.controller]);
};

exports.controller = function ($scope, $timeout, $location, Auth) {
  $scope.forgotPasswordSubmit = function($event, email) {
    //$(".login-page").addClass('logging-in');
    Auth.forgotPassword(email).then(
      function() {
        $scope.message = "We're sending you an email to reset your password. It should arrive momentarily.";
        $scope.completed_with_success = true;
        //$(".login-page").removeClass('logging-in');
      },
      function(response) {
        if(response.status == 401 && !response.data.success) {
          //$(".login-page").removeClass('logging-in');
          console.log('TODO: show error message');
        }
      }
    ); 
  };
};


/*****************
 ** WEBPACK FOOTER
 ** ./app/authorization/forgot-password-controller.js
 ** module id = 304
 ** module chunks = 0
 **/